import { z } from 'zod';
import { vaultPostRequest } from '../helpers';

const responseSchema = z.object({
  accepted: z.boolean(),
  total: z.number(),
  enqueued: z.number(),
  duplicates: z.number(),
  byType: z.record(z.string(), z.number()),
});

export type IWarmNonChallengesResponse = z.infer<typeof responseSchema>;

export async function warmNonChallengesApi(): Promise<IWarmNonChallengesResponse> {
  return vaultPostRequest({
    path: '/img/warm-non-challenges',
    body: {},
    schema: responseSchema,
  });
}
